import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'CircleCI Case Study | Canny';
const Description =
  'Read about how CircleCI uses Canny as their home for feedback to inform their product decisions.';
const Image = 'https://canny.io/images/helmet-cci-case-study.jpg';

export default class CCILandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/circleci' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
